import { type FC } from 'react';

import PendingActionsOutlined from '@mui/icons-material/PendingActionsOutlined';
import PeopleOutlined from '@mui/icons-material/PeopleOutlined';

import { SideNavButton } from '@/src/components/atoms/navButtons';
import { PendingApprovalsPages } from '@/src/config/pages';

import { NavDivider } from './NavDivider';

export const EvaluatorNavLinks: FC = () => (
  <>
    <NavDivider />
    <SideNavButton
      activePages={[...PendingApprovalsPages, 'pending-approvals-not-configured']}
      icon={PendingActionsOutlined}
      page='pending'
    >
      Pending
    </SideNavButton>
    <SideNavButton icon={PeopleOutlined} page='learners'>
      Learners
    </SideNavButton>
    <NavDivider />
  </>
);
